import styles from './RecommendationShoesMeta.module.scss';
import { BasicParagraph } from '~/components/common/text/BasicParagraph';
import { BasicSpan } from '~/components/common/text/BasicSpan';
import type { Size } from '~/features/size/size';

interface Props {
  name: string;
  category: string;
  shoeSize: Size;
  description?: string;
}

export const RecommendationShoesMeta = ({ name, category, shoeSize, description }: Props) => {
  return (
    <div className={styles.container}>
      <BasicParagraph size={30} weight={700} lineHeight={1.8}>
        {name}
      </BasicParagraph>
      <BasicParagraph size={22}>{category}</BasicParagraph>
      <div className={styles.size}>
        <BasicParagraph size={32} weight={700} lineHeight={0.8} fontFamily="numeric">
          {shoeSize.displaySize}
        </BasicParagraph>
        <BasicSpan size={22} lineHeight={1} weight={700} fontFamily="numeric">
          {shoeSize.unit}
        </BasicSpan>
      </div>
      {description && (
        <div className={styles.description}>
          <BasicParagraph size={24} weight={400} lineHeight={1.8}>
            {description}
          </BasicParagraph>
        </div>
      )}
    </div>
  );
};
